import { createRouter, createWebHistory, type RouteRecordRaw } from 'vue-router'

import AccessDeniedPage from '../pages/AccessDeniedPage.vue'
import HomePage from '../pages/HomePage.vue'
import SessionPage from '../pages/SessionPage.vue'

const routes: RouteRecordRaw[] = [
  { path: '/', name: 'home', component: HomePage },
  { path: '/session/:id', name: 'session', component: SessionPage, props: true },
  { path: '/access-denied', name: 'access-denied', component: AccessDeniedPage },
  // Legacy route without ID — redirect to home
  { path: '/session', redirect: '/' },
]

const router = createRouter({
  history: createWebHistory('/aivideo'),
  routes,
})

export default router
